import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LocalTableComponent} from './local-table.component';
import {MatTableModule} from '@angular/material/table';
import {MatMenuModule} from '@angular/material/menu';
import {MatIconModule} from '@angular/material/icon';
import {LocalPaginatorModule} from '../../../modules/shared/modules/local-paginator/local-paginator.module';
import {MatButtonModule} from '@angular/material/button';


@NgModule({
  declarations: [LocalTableComponent],
  exports: [
    LocalTableComponent
  ],
  imports: [
    CommonModule,
    MatTableModule,
    MatMenuModule,
    MatIconModule,
    LocalPaginatorModule,
    MatButtonModule
  ]
})
export class LocalTableModule {
}
